/* eslint-disable import/no-cycle */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';

import styles from './styles';
import { BANK_TRANSFER } from '../../config/constants';
import BankTransferForm from '../BankTransferForm/BankTransferForm';
import Button from '../Button/Button';
import PaymentTypeLabel from '../PaymentTypeLabel/PaymentTypeLabel';


class BankTransfer extends React.Component {
  state = {
    isShowUpdateMessage: false,
    errorMessage: null,
  };

  findEmptyFields = (paymentMethod) => {
    const errors = {
      AccountName: 'Enter Account Name or choose another payment method',
      SortCode: 'Enter Sort Code or choose another payment method',
      AccountNumber: 'Enter Account Number or choose another payment method',
    };
    this.setState({ errorMessage: null });
    return (
      Object.keys(paymentMethod).every(
        (key) => {
          if (!paymentMethod[key]) {
            this.setState({ errorMessage: errors[key] });
            return false;
          }
          return true;
        }
      )
    );
  }

  onUpdate = () => {
    this.setState({ isShowUpdateMessage: true });
    if (this.findEmptyFields(this.props.bank)) {
      this.props.onSubmit();
    }
  }

  renderEditFields = (classes, paymentIndex, updateStatus) => {
    const { isShowUpdateMessage, errorMessage } = this.state;
    return (
      <div>
        <BankTransferForm />
        {!paymentIndex
          && (
            <div>
              {isShowUpdateMessage
                && (
                  <h6 className={classNames(classes.updateText,
                    errorMessage || !updateStatus.status ? classes.rejectedColor : null)}
                  >
                    {errorMessage || updateStatus.payment}
                  </h6>)}
              <Button
                text={'update'}
                onPress={this.onUpdate}
                style={classes.submitButton}
              />
            </div>
          )}
      </div>
    );
  }

  render() {
    const {
      text,
      classes,
      selectedPaymentType,
      setPaymentType,
      paymentIndex,
      updateStatus,
    } = this.props;

    return (
      <PaymentTypeLabel
        type={BANK_TRANSFER}
        text={text}
        selectedPaymentType={selectedPaymentType}
        setPaymentType={setPaymentType}
        paymentIndex={paymentIndex}
        renderPaymentTypeInfo={this.renderEditFields(classes, paymentIndex, updateStatus)}
      />
    );
  }
}

BankTransfer.propTypes = {
  classes: PropTypes.object,
  text: PropTypes.string,
  selectedPaymentType: PropTypes.number,
  setPaymentType: PropTypes.func,
  paymentIndex: PropTypes.bool,
  updateStatus: PropTypes.object,
  onSubmit: PropTypes.func,
  bank: PropTypes.object,
};

BankTransfer.defaultProps = {
  classes: {},
  text: '',
  selectedPaymentType: BANK_TRANSFER,
  setPaymentType: () => { },
  paymentIndex: true,
  updateStatus: {},
  onSubmit: () => { },
  bank: {},
};

export default withStyles(styles)(BankTransfer);
